<template>
  <div class="manage">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          :model="searchForm"
          style="display: flex; height: 39px"
          label-position="left"
          label-width="90px"
        >
          <el-form-item label="创建日期:">
            <el-col :span="11">
              <el-date-picker
                v-model="searchForm.beginCjsj"
                type="date"
                placeholder="开始时间"
                style="width: 100%"
                :picker-options="startTime"
              />
            </el-col>
            <el-col style="text-align: center" class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="searchForm.endCjsj"
                type="date"
                placeholder="结束时间"
                style="width: 100%"
                :picker-options="endTime"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="证件号码:">
            <el-input v-model="searchForm.zjhm" />
          </el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            class="sousuoButton"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
        </el-form>
      </div>
    </div>
    <div
      style="
        width: 95%;
        max-width: 1518px;
        margin: 0 auto;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 51px;
        margin: 0 auto;
      "
    >
      <div class="tablemes">
        <el-table
          ref="cktable"
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
          @selection-change="select"
        >
          <el-table-column>
            <template slot="header" slot-scope="scope">
              <el-button
                v-preventReClick
                class="addButton"
                icon="el-icon-plus"
                size="mini"
                @click="addPupShow"
              >添加</el-button>
              <el-button
                v-preventReClick
                size="mini"
                icon="el-icon-key"
                @click="copyAdd(1)"
              >重置密码</el-button>
              <el-button
                v-preventReClick
                size="mini"
                icon="el-icon-refresh-right"
                @click="copyAdd(2)"
              >恢复</el-button>
              <el-button
                v-preventReClick
                size="mini"
                icon="el-icon-switch-button"
                @click="copyAdd(3)"
              >停用</el-button>
              <el-button
                v-preventReClick
                class="yijiao"
                size="mini"
                icon="el-icon-s-custom"
                @click="copyAdd(4)"
              >移交主信息员身份</el-button>
            </template>
            <el-table-column
              type="selection"
              align="center"
              width="55"
            />

            <el-table-column
              v-for="(item, i) in table"
              :key="i"
              align="center"
              :label="item.label"
              :width="item.key == 'sfzh' ? '200px' : ''"
            >
              <template slot-scope="scope">
                <span
                  :style="[
                    item.key == 'zt' && scope.row.zt == '正常'
                      ? { color: '#1B9200' }
                      : { color: '#7B7B7B' },
                  ]"
                  size="medium"
                  :title="scope.row[item.key]"
                >
                  {{ scope.row[item.key] }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="220px">
              <template slot-scope="scope">
                <el-button
                  v-preventReClick
                  icon="el-icon-view"
                  size="mini"
                  class="queryButtion"
                  @click="handleQuery(scope.$index, scope.row)"
                >查看</el-button>
                <el-button
                  v-if="scope.row.glyzt != '2'"
                  v-preventReClick
                  icon="el-icon-delete"
                  size="mini"
                  class="deleteButtion"
                  @click="handleDelete(scope.$index, scope.row)"
                >移除</el-button>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager,next,jumper,total,sizes"
          :page-sizes="[10, 20, 30, 40]"
          :total="total"
          :page-size="pagesize"
          class="el-page"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <manage-pup ref="managePup" @refresh="loadData" />
    <cyry-dialog
      v-if="dialogFormVisible"
      ref="dialogcyry"
      :cyrytype="cyrytype"
      :dialog-form-visible="dialogFormVisible"
      @close-dialog="closeDialog"
    />
    <!-- 重置密码 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
      title="重置密码"
      :visible.sync="czwindow"
    >
      <el-form ref="pwdForm" :rules="rules" :model="czform">
        <el-form-item label="输入新密码" prop="pwd">
          <el-input v-model="czform.pwd" autocomplete="off" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-preventReClick @click="czwindow = false">取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="submitPassword"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ManagePup from './managePup.vue'
import CyryDialog from './cyryDialog.vue'
import {
  getDwcxxy,
  getCyryxx,
  getDetail,
  disabledWcxxy,
  enableWcxxy,
  removeCgly,
  changeZxxySf,
  resetPwd
} from '@/assets/js/manage.js'
export default {
  components: { ManagePup, CyryDialog },
  props: {},
  data() {
    const pwdValidate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      } else if (value) {
        const reg = new RegExp(/((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,}$))/)
        if (!reg.test(value)) {
          callback(new Error('密码必须同时包含大写、小写、数字和特殊字符(不包含\'_\')其中三项且至少8位'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.endCjsj) {
            return time.getTime() > new Date(this.searchForm.endCjsj).getTime()
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.beginCjsj) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.searchForm.beginCjsj).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      rules: {
        pwd: [{ required: true,validator: pwdValidate, trigger: 'blur' }]
      },
      czwindow: false,
      dialogFormVisible: false, // 对话框的显示隐藏
      checkedTableList: '',
      leixing: '',
      content: {},
      czform: {},
      table: [
        {
          key: 'sjhm',
          label: '手机号'
        },
        {
          key: 'xm',
          label: '姓名'
        },

        {
          key: 'zjhm',
          label: '证件号码'
        },

        {
          key: 'cjsj',
          label: '创建日期'
        },
        {
          key: 'glyztLabel',
          label: '状态'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      searchForm: {
        zjhm: '',
        beginCjsj: '',
        endCjsj: ''
      },

      multipleSelection: [],
      // children property
      cyrytype: ''
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // this.loadLabel()
    this.loadData()
  },
  beforeDestroy() {},
  methods: {
    submitPassword() {
      this.$refs['pwdForm'].validate((valid) => {
        if (valid) {
          resetPwd({
            id: this.checkedTableList[0].id,
            pwd: this.czform.pwd
          }).then((e) => {
            this.$message({
              type: 'success',
              message: '重置成功!'
            })
            this.czwindow = false
          })
        }
      })
    },
    loadLabel() {
      getCyryxx().then((e) => {
        this.$refs.managePup.xxyList = e.data.data
      })
    },
    loadData() {
      getDwcxxy({
        page: this.currentPage,
        size: this.pagesize,
        param: this.searchForm
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    copyAdd(type) {
      if (this.checkedTableList == '') {
        this.$message.warning('请先选中一条数据!')
      } else {
        if (type == 1) {
          // 重置密码
          this.czwindow = true
        } else if (type == 2) {
          // 恢复
          this.$confirm('是否恢复?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              enableWcxxy(this.checkedTableList[0].id).then((e) => {
                this.$message({
                  type: 'success',
                  message: '恢复成功!'
                })
                this.loadData()
                this.checkedTableList = ''
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        } else if (type == 3) {
          // 停用
          this.$confirm('是否停用?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              disabledWcxxy(this.checkedTableList[0].id).then((e) => {
                this.$message({
                  type: 'success',
                  message: '停用成功!'
                })
                this.loadData()
                this.checkedTableList = ''
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        } else if (type == 4) {
          // 移交主信息员身份
          this.$confirm('是否移交主信息员身份?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              changeZxxySf(this.checkedTableList[0].id).then((e) => {
                this.$message({
                  type: 'success',
                  message: '已提交移交主信息员身份操作,请等待审核结果!'
                })
                this.loadData()
                this.checkedTableList = ''
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        }
      }
    },

    select(row) {
      this.checkedTableList = row
      if (row.length > 1) {
        this.$refs.cktable.clearSelection()
        this.$refs.cktable.toggleRowSelection(row.pop())
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadData()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.loadData()
    },
    toggleSelection(rows) {},
    handleSelectionChange(val) {},
    addPupShow() {
      this.$refs.managePup.dialogVisible = true
    },
    // 关闭对话框
    closeDialog() {
      this.dialogFormVisible = false
    },
    // 查看
    handleQuery(index, row) {
      getDetail(row.id).then((e) => {
        this.setDataSource(e.data.data)
      })
    },
    setDataSource(data) {
      this.cyrytype = true
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.dialogcyry.getformMes(data)
      })
    },
    handleEdit(index, row) {},
    handleDelete(intex, row) {
      this.$confirm('是否移除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeCgly(row.id).then((e) => {
            this.$message({
              type: 'success',
              message: '成功!'
            })
            this.loadData()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 50px 30px !important;
}
/deep/.el-form--inline .el-form-item__content {
  display: inline-block;
  vertical-align: middle !important;
}
/deep/.el-table--border {
  border-right: none;
  border-bottom: none;
  z-index: 0 !important;
}
.manage {
  .headerSearch {
    width: 95%;
    max-width: 1518px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 27px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }

  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      // border-radius: 3px;
      border-color: #4170ff;
    }
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .addButton {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .yijiao {
      background-color: #4ca89d;
      border-color: #4ca89d;
      border-radius: 3px;
      color: white;
    }
    .queryButtion,
    .editButtion {
      padding: 0;
      color: #fff;
      width: 59px;
      height: 26px;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .deleteButtion {
      padding: 0;
      color: #fff;
      width: 59px;
      height: 26px;
      background: #fe5622;
      border-radius: 3px;
      border-color: #fe5622;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/.el-table__header-wrapper .el-checkbox {
  //找到表头那一行，然后把里面的复选框隐藏掉
  display: none;
}
</style>
